<template>
  <q-page>
    <order-product
      :product-id="Number($route.params.productId)"
      @order-product-success="orderProductSuccess"
      @show-geolocation="orderProductShowGeolocation"
      @close-pop-up="$router.push({ name: 'homepage' })"
    />
    <geolocation
      v-if="showGeolocationDialog"
      :show-choose-delivery-method-text="showChooseDeliveryMethodText"
      :tab="geolocationDeliveryType"
      @close-pop-up="showGeolocationDialog = false"
      @geolocation-success="updateGeolocation"
    />
    <div itemtype="http://schema.org/Product" itemscope>
      <meta itemprop="mpn" :content="productStore.info.id" />
      <meta itemprop="name" :content="productStore.info.name" />
      <link v-if="productStore.info.photo !== null" itemprop="image" :href="$assetsUrl() + productStore.info.photo" />
      <meta itemprop="description" :content="productStore.info.description" />
      <div itemprop="offers" itemtype="http://schema.org/AggregateOffer" itemscope>
        <meta itemprop="lowPrice" :content="productStore.info.price" />
        <meta itemprop="highPrice" :content="productStore.info.price" />
        <meta itemprop="priceCurrency" :content="currency" />
      </div>
    </div>
  </q-page>
</template>

<script>
import { createMetaMixin, Cookies } from 'quasar'

import OrderProduct from '../components/OrderProduct.vue'
import Geolocation from '../components/Geolocation.vue'

import { mapState, mapStores } from 'pinia'
import { useProductStore } from 'stores/product'
import { useSettingsStore } from 'stores/settings'
import { useCartStore } from 'stores/cart'
import { useUserStore } from 'stores/user'

export default {
  name: 'ProductView',
  components: {
    'order-product': OrderProduct,
    geolocation: Geolocation
  },
  mixins: [
    createMetaMixin(function mymeta() {
      return {
        title:
          this.productStore.info.seo_title !== null
            ? this.productStore.info.seo_title
            : `${this.productStore.info.name} - ${this.websiteName}`,
        meta: {
          description: {
            name: 'description',
            content:
              this.productStore.info.seo_description !== null
                ? this.productStore.info.seo_description
                : this.productStore.info.description
          },
          property: {
            property: 'og:image',
            content: `${this.assetsUrl}${this.productStore.info.photo}`
          }
        }
      }
    })
  ],
  preFetch({ store, currentRoute, ssrContext }) {
    const productStore = useProductStore(store)
    return new Promise(resolve => {
      const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies

      let translateLanguage = null
      if (cookies.has('translate_language') && cookies.get('translate_language').length === 5) {
        translateLanguage = cookies.get('translate_language')
      }
      productStore.fetch(currentRoute.params.productId, { translateLanguage }).then(() => {
        resolve()
      })
    })
  },
  data() {
    return {
      showGeolocationDialog: false,
      geolocationDeliveryType: 'pickup',
      showChooseDeliveryMethodText: true
    }
  },
  computed: {
    ...mapStores(useProductStore),
    ...mapState(useSettingsStore, {
      websiteName: store => store.website.name,
      currency: store => store.localization.currency,
      companyName: store => store.website.name,
      autoOpenGeolocation: store => store.auto_open_geolocation
    }),
    ...mapState(useCartStore, {
      deliveryType: store => store.delivery_type
    }),
    ...mapState(useUserStore, {
      userLogged: store => store.delivery_type
    }),
    ...mapState(useUserStore, {
      userLogged: 'isLogged'
    })
  },
  watch: {
    $route() {
      this.trackView()
    }
  },
  mounted() {
    if (
      this.userLogged === false &&
      this.$q.localStorage.has('be_know_delivery_pickup') === false &&
      this.deliveryType !== 'table' &&
      this.autoOpenGeolocation
    ) {
      this.showGeolocationDialog = true
    }
  },
  methods: {
    orderProductSuccess() {
      this.$q.notify({ message: this.$t('order-product.product-added-success'), position: 'top', color: 'positive' })
      this.$router.push({ name: 'homepage' })
    },
    orderProductShowGeolocation() {
      this.openGeolocation('pickup')
    },
    openGeolocation() {
      this.showGeolocationDialog = true
    },
    updateGeolocation() {
      window.location.reload()
      this.showGeolocationDialog = false
    },
    trackView() {
      if (this.$q.localStorage.has('be_cookie_consent')) {
        try {
          const acceptedCookies = this.$q.localStorage.getItem('be_cookie_consent')
          const trackers = this.$store.state.settings.trackers
          Object.keys(trackers).forEach(type => {
            if (type === 'gtag' && acceptedCookies.statistically) {
              this.$gtag.event('view_item', {
                currency: this.currency,
                value: this.productStore.info.price,
                items: [
                  {
                    item_id: this.productStore.info.id,
                    item_name: this.productStore.info.name,
                    price: this.productStore.info.price,
                    currency: this.currency
                  }
                ]
              })
            } else if (type === 'fbpixel' && acceptedCookies.marketing) {
              fbq('track', 'PageView', {
                content_name: this.productStore.info.name,
                content_category: this.selectedCategory.name,
                content_ids: [this.productStore.info.id],
                content_type: 'product',
                value: this.productStore.info.price,
                currency: this.currency
              })
            }
          })
          if (acceptedCookies.performance && this.$amplitude !== null) {
            this.$amplitude.track({
              event_type: '[BE] Product viewed',
              event_properties: {
                productId: this.productStore.info.id,
                productName: this.productStore.info.name,
                productPrice: this.productStore.info.price,
                companyId: this.companyId,
                companyName: this.companyName
              }
            })
          }
        } catch (err) {
          // to do
        }
      }
    }
  }
}
</script>
